import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "login-container"
};
const _hoisted_3 = {
  class: "input-container"
};
const _hoisted_4 = {
  class: "input-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("h1", null, "AdminLogin", -1)), _createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("a", {
    class: "input-name"
  }, "用户名：", -1)), _createVNode(_component_el_input, {
    modelValue: $data.username,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.username = $event),
    placeholder: "请输入用户名",
    class: "username-input"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("a", {
    class: "input-name"
  }, "密码：", -1)), _createVNode(_component_el_input, {
    modelValue: $data.password,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.password = $event),
    placeholder: "请输入密码",
    class: "password-input",
    type: "password",
    "show-password": "",
    onKeyup: _withKeys($options.login, ["enter", "native"])
  }, null, 8, ["modelValue", "onKeyup"])]), _createVNode(_component_el_button, {
    class: "submit",
    type: "primary",
    onClick: $options.login
  }, {
    default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("登录")])),
    _: 1
  }, 8, ["onClick"])])]);
}